import { formatPayout, formatPayoutAmount } from './formatCurrency';

export const getPayoutRangeString = (payouts) => {
    if(!payouts) return null

    const rated = payouts
        .map(payout => ({ value: parseFloat(payout.value), type: payout.type }))
        .filter(payout => payout.value != 0 && !isNaN(payout.value))
        .sort((a, b) => a.value - b.value)

    if(rated.length == 0) {
      return null;
    }

    const low = rated[0]
    const high = rated[rated.length - 1]

    if(low.value == high.value) {
      return formatPayout(high.value, high.type);
    }

    return `${formatPayoutAmount(low.value, low.type)} - ${formatPayout(high.value, high.type)}`;
}
